export * from './components/PolicyTip/index';